import { useTrialsContext } from 'contexts/TrialsContextProvider';

import TrialFormField from './TrialFormField';

const NameField = ({
  fieldName,
  trackingEventName = 'profile',
  ...inputProps
}) => {
  const { setNameErrors, nameErrors } = useTrialsContext() || {};

  return (
    <TrialFormField
      errors={nameErrors}
      fieldName={fieldName}
      id={`trial-${fieldName}`}
      isUserProperty
      setErrors={setNameErrors}
      trackingEventName={trackingEventName}
      {...inputProps}
    />
  );
};

export default NameField;
